import { render, staticRenderFns } from "./_resupply.tab.vue?vue&type=template&id=2aaf6248&scoped=true&"
import script from "./_resupply.tab.vue?vue&type=script&lang=js&"
export * from "./_resupply.tab.vue?vue&type=script&lang=js&"
import style0 from "./_resupply.tab.vue?vue&type=style&index=0&id=2aaf6248&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aaf6248",
  null
  
)

export default component.exports